import AdminUserPage from './AdminUserPage';

const Jay = () => <AdminUserPage user="Jay" />;

export default Jay;
